import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { CleryBioPersonInfo, DataState, ClergyBioRoutes } from '../model/clergy-bio-app-models';
import ClergyBioComponentLoader from '../components/clergy-bio-component-loader';
import { LabelAndValue } from '../../../global/components/data-display/label-value';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { religiousOrder } from './model/form-models';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { ClericIcon } from '../../account-info/components/cleric-indicator';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';

interface Props {
	settings: ClergyBioSettings;
	basePath: string;
}

function ClergyBioPersonalInfoReview(props: Props) {

	const { settings, basePath } = props;
	const headerClasses = headerIconStyles();

	const loadingState = useSelector<TcsmStates, DataState>(state => state?.clergyBioState?.loaded?.personInfo);
	const personalInfo = useSelector<TcsmStates, CleryBioPersonInfo>(state => state?.clergyBioState?.personInfo);
	const buttonClasses = buttonStyles();

	const AddressView = () => {
		return (
			<>
				<p>{personalInfo?.publishedAddress?.details.address1} {personalInfo?.publishedAddress?.details.address2}<br />
					{personalInfo?.publishedAddress?.details.city}, {personalInfo?.publishedAddress?.details.state}<br />
					{personalInfo?.publishedAddress?.details.postalCode},<br />
					{personalInfo?.publishedAddress?.details.country}</p>
			</>
		);
	};


	function renderContent() {
		return (
			<>
				<ContentSpacer>
					<div className={headerClasses.iconHeader}>
						<ClericIcon />
						<h3>{settings?.personalInfoSubTitle}</h3>
					</div>
				</ContentSpacer>
				<LabelAndValue label={settings?.nameAppearAsLabel} value={`${personalInfo?.personal?.details?.firstNamePub || personalInfo?.personal?.details?.firstName} ${personalInfo?.personal?.details?.middleNamePub || personalInfo?.personal?.details?.middleName} ${personalInfo?.personal?.details?.lastName}`} />
				<LabelAndValue label={settings?.lastNameAtBirthLabel} value={personalInfo?.personal?.details?.lastNameAtBirth} />
				<LabelAndValue label={settings?.placeAtBirthLabel} value={personalInfo?.personal?.details?.placeOfBirth} />
				<LabelAndValue label={settings?.religiousOrderLabel} value={religiousOrder?.filter(a => a?.value === personalInfo?.personal?.details?.religiousOrder)[0]?.text} />
				<LabelAndValue label={settings?.personalWebsiteLabel} value={personalInfo?.personal?.details?.personalWebsite?.url} />
				<LabelAndValue label={settings?.publishedAddressLabel} value={<AddressView />} />

			</>
		);
	}

	return (
		<DividerSection sectionText={settings?.personalTitle} >
			<ClergyBioComponentLoader
				state={loadingState}
				content={renderContent()}
			/>
			<ContentSpacer>
				<Link className={buttonClasses.primaryButton} to={`${basePath}${ClergyBioRoutes.Personal}`}>{settings?.updateButtonText}</Link>
			</ContentSpacer>
		</DividerSection>
	);
}


export default ClergyBioPersonalInfoReview;